import { DsImprintModule } from '@bmw-ds/components';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { routes } from './app.routes';
import { provideOAuthClient } from 'angular-oauth2-oidc';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      DsImprintModule.forRoot({
        phone: 'y',
        electronicContact: 'y',
        region: 'EU',
      }),
      BrowserAnimationsModule
    ),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    provideOAuthClient(),
  ],
};
